import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger);

export default function item(){
  const dls = document.querySelectorAll(".site-item .item-list");
  const spans = document.querySelectorAll(".site-item .item-pager a");

  console.log(dls)
  dls.forEach((dl, index) => {
    ScrollTrigger.create({
      trigger: dl,
      start: "top center + 25%",
      end: "bottom center + 25%",
      //markers: true,
      onEnter: () => setActive(index),
      onEnterBack: () => setActive(index),
    })
  })

  function setActive(index) {
    spans.forEach((span, i) => {
      span.classList.toggle("active", i === index)
    })
  }
}


